// Condos, units, tenants, the service team and tickets are paged:
// `page` (1-based) and `page_size` (1-100, default 10), answered with
// { page, page_size, total, results }. Roles, categories, holidays, working
// hours, SLA tiers and routing rules are plain arrays. Dropdowns need the
// whole set, so this walks the pages at the maximum size.
export const MAX_PAGE_SIZE = 100;

export async function listAllPages(listFn, query = {}) {
  const results = [];
  let page = 1;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    // Each page depends on the previous one's total, so they run in order.
    // eslint-disable-next-line no-await-in-loop
    const { data } = await listFn({
      ...query,
      page,
      page_size: MAX_PAGE_SIZE,
    });
    results.push(...data.results);
    if (!data.results.length || results.length >= data.total) {
      return results;
    }
    page += 1;
  }
}
